import ArrowIcon from '@images/icons/arrow-down.svg?react'
import { resolveTransferTimeLabel } from '@utils'
import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import type { PaymentMethodOption } from '../../PaymentMethodSelect'
import PaymentOptionIcon from '../../PaymentOptionIcon'

import styles from './MethodCard.module.scss'

type MethodCardProps = {
  method: PaymentMethodOption
  selected: boolean
  disabled: boolean
  onClick: () => void
  collapsible?: boolean
  expanded?: boolean
}

function MethodCard({ method, selected, disabled, onClick, collapsible, expanded }: MethodCardProps) {
  const title = method.title || tr(`METADATA.PAYMENT_OPTIONS.${method.paymentMethod}`, method.paymentMethod)
  const transferTimeLabel = resolveTransferTimeLabel(method)

  return (
    <div
      className={cn(styles['deposit-method-card'], { [styles.selected]: selected, [styles.disabled]: disabled })}
      data-test={method.dataTest}
      onClick={() => !disabled && onClick()}
    >
      <div className={styles['deposit-method-icon']}>
        <PaymentOptionIcon paymentOption={method.paymentMethod} />
      </div>
      <div className={styles['deposit-method-text']}>
        <span className={styles['deposit-method-name']}>{title}</span>
        {transferTimeLabel && <span className={styles['deposit-method-time']}>{transferTimeLabel}</span>}
      </div>
      {collapsible && (
        <span className={cn(styles['deposit-method-chevron'], { [styles.expanded]: expanded })}>
          <ArrowIcon />
        </span>
      )}
    </div>
  )
}

export default MethodCard
